import { FC } from 'react';
import { IconGiftCloseHeader, NoImage } from '../../assets/images';
import useImageHeader from '../../hooks/useImageHeader';
import { Mode } from '../../models/common';
import { getCidFromLocalStorage, getMailFromLocalStorage } from '../../utils/commonFunction';
import { getGroupId } from '../../utils/commonFunction/getGroupId';
import './style.scss';

interface IProps {}

const HeaderTop: FC<IProps> = (props) => {
  const groupId = getGroupId();
  const handleClick = () => {
    const cid = getCidFromLocalStorage();

    const mailaddress = getMailFromLocalStorage();
    if (!cid || cid === '') {
      window.location.href = `${process.env.REACT_APP_APP_ROOT}/?groupId=${groupId}&mailaddress=${mailaddress}`;
    } else {
      window.location.href = `${process.env.REACT_APP_APP_ROOT}/?cid=${cid}&groupId=${groupId}&mailaddress=${mailaddress}`;
    }
  };

  const { imageHeader } = useImageHeader(Mode.gift, groupId);
  return (
    <div className="header-top-furusato">
      <img src={imageHeader || NoImage} alt="banner" className="header-top-furusato__banner" />
      <div className="header-top-furusato__wrap-close" onClick={handleClick}>
        <IconGiftCloseHeader />
      </div>
    </div>
  );
};

export default HeaderTop;
